import React from 'react';

import { UserMenuToolbar } from 'components/UserMenuToolbar';
import { Link } from 'react-router-dom';

import useHoustonTheme from '@eduzz/houston-styles/useHoustonTheme';

import Logo from '../../../assets/Logo';
import { ToolbarContainer } from './styles';

const Toolbar: React.FC = () => {
  const theme = useHoustonTheme();
  return (
    <ToolbarContainer>
      <Link to='/'>
        <Logo color={theme.brandColor.primary.pure} />
      </Link>
      <UserMenuToolbar />
    </ToolbarContainer>
  );
};

export default Toolbar;
